import { Link } from "react-router-dom";
import HeroImg from "../../assets/images/On-campus-img.png";
import FameWallNaati from "components/Frontend/FameWallNaati";

const BannerSection = (props) => {
  const { title, subTitle, blueBoxText, hideFameWall, videoId } = props;


  return (
  <div className="banner-section noc-banner">
    <div className="container">
      <div className="row">
        <div className="banner-content">
          {title && title()}
          {subTitle && subTitle()}
          <div className="iframe-video-outer position-relative">
            <div className="banner-img-wrapper">
              {videoId ? (
                <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '12px', zIndex: 1 }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${videoId}?si=r43WkyC8a7wL2Z8Z`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                  ></iframe>
                </div>
              ) : (
                <img
                  className="banner-img"
                  src={HeroImg}
                  alt="LA"
                />
              )}
            </div>
            <img
              className="emoji1 position-absolute"
              src="/images/web-new-images/emojis/emoji-1.png"
              alt="LA"
            />
            <img
              className="emoji2 position-absolute"
              src="/images/web-new-images/emojis/emoji-2.png"
              alt="LA"
            />
            <img
              className="emoji3 position-absolute"
              src="/images/web-new-images/emojis/emoji-3.png"
              alt="LA"
            />
            <img
              className="emoji4 position-absolute"
              src="/images/web-new-images/emojis/emoji-4.png"
              alt="LA"
            />
          </div>
          {!hideFameWall && <FameWallNaati show={false} />}
          {/* <CrackedCodeSlider title={`<span className="fw-700">WHAT OUR</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">STUDENTS SAY</span>`} /> */}
          {blueBoxText && blueBoxText()}
          <Link to="/contact" className="primary-btn mt-2">
            ENROLL IN OUR PROGRAM TODAY
            <img
              src="/images/web-new-images/right-arrow.svg"
              alt="Register Now"
            />
          </Link>
        </div>
      </div>
    </div>
  </div>)
};
export default BannerSection;